import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from 'react';
import Consumer from './page/Consumer';
import OrderLoader from './componets/OrderLoader';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="app-background">
        <React.Fragment key={3}>
          <Router>
            <Routes>
              <Route path="/chef" element={<OrderLoader />} />
              <Route path="/consumer" element={<Consumer />} />
              <Route path="/" element={<div></div>} />
            </Routes>
          </Router>
        </React.Fragment>
      </div>

    </QueryClientProvider>
  );
}

export default App;
